/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * Transfer Transactions
 * PO Transactions

PO Transactions Viewer

API for printing labels using ZPL
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ErrorResp,
  GetItemCountsParams,
  GetTransactionsParams,
  ItemCounts,
  Transactions,
} from '../model';
import { customInstanceNoFadcode } from '../mutator/customInstanceNoFadcode';
import type { ErrorType } from '../mutator/customInstanceNoFadcode';

/**
 * @summary Get Transactions
 */
export const getTransactions = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsParams,
  signal?: AbortSignal,
) => {
  return customInstanceNoFadcode<Transactions>({
    url: `/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/transactions`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTransactionsQueryKey = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsParams,
) => {
  return [
    `/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactions>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionsQueryKey(branch, from, to, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactions>>> = ({ signal }) =>
    getTransactions(branch, from, to, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(branch && from && to),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactions>>>;
export type GetTransactionsQueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Transactions
 */
export const useGetTransactions = <
  TData = Awaited<ReturnType<typeof getTransactions>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTransactionsQueryOptions(branch, from, to, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Item Counts
 */
export const getItemCounts = (
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountsParams,
  signal?: AbortSignal,
) => {
  return customInstanceNoFadcode<ItemCounts>({
    url: `/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/itemCount`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetItemCountsQueryKey = (
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountsParams,
) => {
  return [
    `/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/itemCount`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetItemCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getItemCounts>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCounts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetItemCountsQueryKey(branch, from, to, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemCounts>>> = ({ signal }) =>
    getItemCounts(branch, from, to, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(branch && from && to),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getItemCounts>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetItemCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getItemCounts>>>;
export type GetItemCountsQueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Item Counts
 */
export const useGetItemCounts = <
  TData = Awaited<ReturnType<typeof getItemCounts>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCounts>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetItemCountsQueryOptions(branch, from, to, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
